import { ApplicationConfig, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';
import { provideStore, provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { workspaceFeature, workspaceEffects } from './state/workspace';
import { userFeature, userEffects } from './state/user';
import { historyEntriesFeature, historyEntriesEffects } from './state/history-entries';
import { devopsFeature } from './state/devops';
import { docsFeature, docsEffects } from './state/docs';
import { defineEffects } from './state/define';
import { architectureEffects } from './state/architecture';
import { reposEffects } from './state/repos';
import { ticketsFeature, ticketsEffects } from './state/tickets';
import { dbDesignEffects } from './state/db-design';
import { designEffects } from './state/design';
import { globalChatEffects } from './state/global-chat';
import { workflowFeature, workflowEffects } from './state/workflow';
import { AppstraxServices } from '@appstrax/services';
import { environment } from '../environments/environment';

import { routes } from './app.routes';

AppstraxServices.init({
  apiUrl: environment.appstraxServicesUrl,
  apiKey: environment.appstraxServicesApiKey,
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimations(),
    provideStore(),
    provideState(workspaceFeature),
    provideEffects(workspaceEffects),
    provideState(userFeature),
    provideEffects(userEffects),
    provideState(historyEntriesFeature),
    provideEffects(historyEntriesEffects),
    provideState(devopsFeature),
    provideState(docsFeature),
    provideEffects(docsEffects),
    provideEffects(defineEffects),
    provideEffects(architectureEffects),
    provideEffects(reposEffects),
    provideState(ticketsFeature),
    provideEffects(ticketsEffects),
    provideEffects(dbDesignEffects),
    provideEffects(designEffects),
    provideEffects(globalChatEffects),
    provideState(workflowFeature),
    provideEffects(workflowEffects),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
  ],
};
